import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditVehicleTypeComponent } from '@app/core/windows'; 


@Component({
  selector: 'vehicles-types-crud',
  templateUrl: './vehicles-types-crud.component.html',
  providers: [ DatasourceService ]
})
export class VehiclesTypesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditVehicleTypeComponent, {static: false}) window !: CreateEditVehicleTypeComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Tipo de Vehículo';

  protected name: string = 'Tipos de Vehículos';

  protected table: string = 'vehicles_types';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Cuota': {
                cell.format = "$#,##0.00";
              }; break; 
            }
          }
        });
      }
    });

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}